// extracted by mini-css-extract-plugin
module.exports = {"subrow":"merchant-log-details_subrow_2wKh3"};